import React, { FC } from "react"
import { Contents } from "./Contents"
import styled from "styled-components"
import { TwoColumnList } from "components/views/atoms/Atoms"
import { ITwoColumnBulletList } from "contentful-types"
import { DynamicContentComponentProps } from "./DynamicContentComponentProps"

const StyledItemList = styled(TwoColumnList)`
  li {
    div {
      display: inline-block;
      margin-top: -0.2rem;
      vertical-align: text-top;
    }
    p {
      margin: 0;
    }
  }
`

const TwoColumnBulletList: FC<DynamicContentComponentProps<ITwoColumnBulletList>> = ({ content }) => {
  const {
    fields: { content: internalContent }
  } = content
  return (
    <StyledItemList>
      <Contents contents={internalContent} asList />
    </StyledItemList>
  )
}

export { TwoColumnBulletList }
